// extracted by mini-css-extract-plugin
export default {"wholeTableReservationWrapper":"HOQtOY","mobile":"IoaFRN","occupied":"e3clB0","selected":"PRVGFi","wholeTableReservationWrapperHover":"sPinJq"};